import { Col } from '@/components/grid/grid-component';
import { GoCircle } from 'react-icons/go';
import styled, { css } from 'styled-components';

const StatusCircle = styled(GoCircle)`
  margin-left: 8px;
  ${(props) => {
    switch (props.status) {
      case 'active':
        return css`
          color: ${props.theme.COLOR_STATUS_GREEN};
        `;
      case 'new':
        return css`
          color: ${props.theme.COLOR_STATUS_BLUE};
        `;
      case 'suspended':
        return css`
          color: ${props.theme.COLOR_STATUS_ORANGE};
        `;
      default:
        return null;
    }
  }}
`;

const ImageSection = styled(Col)`
  display: flex;
  flex-direction: column;
`;

const Spacer = styled.div`
  height: 16px;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
`;

const Bumper = styled.div`
  height: 24px;
`;

const Button = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    margin: 0 8px 0 0;
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 0px 8px;
`;

const CustomerFormStyle = {
  ImageSection,
  StatusCircle,
  Spacer,
  Bumper,
  Button,
  MainContainer,
};

export default CustomerFormStyle;
